module.exports = __webpack_public_path__ + "statics/img/1.532b4e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/technological/1.png
// module id = Bo25
// module chunks = 1